var _rect, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgClipboard(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_156_26066",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 38,
    height: 38
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_156_26066)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.5416 32.2736L17.588 25.3204L20.3458 22.523L24.5416 26.7189L33.4348 17.8257L36.1922 20.623L24.5416 32.2736ZM34.3848 15.4903H30.2151V7.78496H27.8005V12.2709H10.1994V7.78496H7.78479V30.2153H17.1791V34.3584H7.78479C6.62341 34.3584 5.64254 33.9625 4.84216 33.1705C4.04179 32.3786 3.6416 31.3935 3.6416 30.2153V7.78496C3.6416 6.6067 4.03757 5.61725 4.8295 4.81661C5.62143 4.0157 6.60653 3.61525 7.78479 3.61525H14.0785C14.4216 2.64784 15.0448 1.85406 15.9481 1.23392C16.8511 0.61378 17.8684 0.303711 18.9999 0.303711C20.0996 0.303711 21.1046 0.61378 22.015 1.23392C22.9254 1.85406 23.5741 2.64784 23.9609 3.61525H30.2151C31.3933 3.61525 32.3828 4.0157 33.1834 4.81661C33.9843 5.61725 34.3848 6.6067 34.3848 7.78496V15.4903ZM18.9999 7.2965C19.4485 7.2965 19.8246 7.14041 20.1281 6.82823C20.4315 6.51605 20.5833 6.14436 20.5833 5.71317C20.5833 5.26456 20.4315 4.88852 20.1281 4.58505C19.8246 4.28157 19.4485 4.12984 18.9999 4.12984C18.5513 4.12984 18.1753 4.28157 17.8718 4.58505C17.5683 4.88852 17.4166 5.26456 17.4166 5.71317C17.4166 6.14436 17.5683 6.51605 17.8718 6.82823C18.1753 7.14041 18.5513 7.2965 18.9999 7.2965Z",
    fill: "#71717A"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClipboard);
export default __webpack_public_path__ + "static/media/clipboard.c7f09bb3f6c26cadad5dc26a17990e48.svg";
export { ForwardRef as ReactComponent };